import { CardModel, PileModel } from "../../interface/game";
import { WinCondition } from "./win-condition";

export function winAllCardsOnPiles(pileIds: string[]): WinCondition {
    return (piles: {[key: string]: PileModel}, cards: {[key: string]: CardModel}) => {
        for (const pileId of Object.keys(piles)) {
            if (!pileIds.includes(pileId) && piles[pileId].cards.length > 0) {
                return false;
            }
        }

        return true;
    }
}